// extracted by mini-css-extract-plugin
module.exports = {"card":"styles__card--T6dLJ","checkbox":"styles__checkbox--2cS1-","item":"styles__item--2OQJA","label":"styles__label--3WctI","subheader":"styles__subheader--2bch-"};